import config from "../config";

let memoryAuthToken = null;

const safeStorageGet = (storage, key) => {
  try {
    return storage.getItem(key);
  } catch (e) {
    return null;
  }
};

const safeStorageSet = (storage, key, value) => {
  try {
    storage.setItem(key, value);
    return true;
  } catch (e) {
    return false;
  }
};

const safeStorageRemove = (storage, key) => {
  try {
    storage.removeItem(key);
  } catch (e) {
    // Storage can be unavailable in embedded webviews/private mode.
  }
};

export const getAuthToken = () => {
  let token = safeStorageGet(sessionStorage, config.tokenKey);
  if (!token) {
    token = safeStorageGet(localStorage, config.tokenKey);
    if (token) {
      safeStorageSet(sessionStorage, config.tokenKey, token);
    }
  }
  return token || memoryAuthToken;
};

export function setAuthToken(token, rememberMe) {
  memoryAuthToken = null;
  safeStorageRemove(localStorage, config.tokenKey);
  safeStorageRemove(sessionStorage, config.tokenKey);

  if (!token) {
    return {
      storageWriteSucceeded: false,
      memoryFallbackUsed: false,
    };
  }

  const storage = rememberMe ? localStorage : sessionStorage;
  memoryAuthToken = token;
  const storageWriteSucceeded = safeStorageSet(storage, config.tokenKey, token);
  return {
    storageWriteSucceeded,
    memoryFallbackUsed: !storageWriteSucceeded,
  };
}

// The Lobby delivers the JWT in the URL fragment. It may arrive bare (#<jwt>)
// or key-prefixed (#token=<jwt>, #access_token=<jwt>, #id_token=<jwt>).
// Extract the bare token defensively; ignore anything that isn't a JWT.
export const extractTokenFromHash = (hash) => {
  if (!hash) return null;
  const raw = hash.replace(/^#/, "");
  if (!raw) return null;

  let candidate = raw;
  if (raw.includes("=")) {
    const params = new URLSearchParams(raw);
    candidate =
      params.get("token") ||
      params.get("access_token") ||
      params.get("id_token") ||
      params.get("jwt") ||
      raw;
  }
  candidate = candidate.trim();
  // a JWT is three base64url segments separated by dots
  return /^[\w-]+\.[\w-]+\.[\w-]+$/.test(candidate) ? candidate : null;
};

// The Lobby may also deliver the JWT as a `tref` query param instead of (or
// as a fallback to) the URL fragment. Same JWT-shape validation as
// extractTokenFromHash; `search` can be a raw query string with or without
// a leading "?" (URLSearchParams accepts either).
export const extractTokenFromQuery = (search) => {
  if (!search) return null;
  const params = new URLSearchParams(search);
  const candidate = params.get("tref")?.trim();
  if (!candidate) return null;
  return /^[\w-]+\.[\w-]+\.[\w-]+$/.test(candidate) ? candidate : null;
};
